import { Button, CloseButton, ScrollArea, Stack } from '@mantine/core';
import * as React from 'react';
import {
    DialogSize,
    ResizableDialog,
} from '../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { ValidationEntrySeverity } from '../../../../../react-commons/components/ValidationEntrySeverity';
import { ControlledInputs } from '../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { DisplayComponentBaseView } from '../../../../../react-commons/views/DisplayComponentBaseView';
import { getEnumFormatter } from '../../../resource/enumerations/utils/getEnumFormatter';

export const uploadFilesDisplay = (
    placeholder: string,
    fileNames: string[],
    setFileNames: (newPaths: string[]) => void,
    disabled?: boolean
) => (
    <ControlledInputs.MultilineString
        nullable={true}
        readOnly={true}
        resize={undefined}
        disabled={disabled}
        value={fileNames.toString().split(',').join('\n')}
        placeholder={placeholder}
        rows={fileNames.length}
        maxRows={fileNames.length}
        endingIcon={
            <CloseButton
                size="md"
                variant="transparent"
                onClick={() => {
                    setFileNames([]);
                }}
            />
        }
    />
);

export const ImportProjectDialog = ({
    onClose,
    onSubmit,
}: {
    onClose: () => void;
    onSubmit: (name: string, selectedFiles: FileList, errorLevel: ValidationEntrySeverity) => void;
}) => {
    const [selectedFiles, setSelectedFiles] = React.useState<FileList>();
    const [selectedFileNames, setSelectedFileNames] = React.useState<string[]>([]);

    const [errorLevel, setErrorLevel] = React.useState<ValidationEntrySeverity>(ValidationEntrySeverity.CRITICAL);
    const [projectName, setProjectName] = React.useState<string>('');
    const handleSubmit = () => {
        if (selectedFiles) {
            onSubmit(projectName, selectedFiles, errorLevel);
        }
    };

    const importFilesStep = () => {
        return (
            <Stack>
                <Button component="label" variant={'filled'} size={'sm'} w={'100%'}>
                    Choose File
                    <input
                        hidden
                        accept={'.pvt'}
                        type={'file'}
                        onChange={(e) => {
                            const files = e.target.files;
                            const fileNames: string[] = [];
                            if (files && files.length > 0) {
                                setSelectedFiles(files);
                                Array.from(files).forEach((file) => {
                                    fileNames.push(file.name);
                                });
                                setSelectedFileNames(fileNames);
                                setProjectName(fileNames[0].replace('.pvt', ''));
                            }
                        }}
                    />
                </Button>
                {uploadFilesDisplay('No Files Selected', selectedFileNames, setSelectedFileNames)}
                <ControlledInputs.String
                    nullable={false}
                    label={'Project Name'}
                    value={projectName}
                    readOnly={false}
                    onChange={(value) => setProjectName(value)}
                />
                <ControlledInputs.Enum
                    label={'Error Level'}
                    value={errorLevel}
                    enumType={ValidationEntrySeverity}
                    enumFormatter={getEnumFormatter(ValidationEntrySeverity)}
                    onChange={(value) => setErrorLevel(value)}
                    readOnly={false}
                    nullable={false}
                />
            </Stack>
        );
    };

    return (
        <ResizableDialog
            onClose={onClose}
            title={'Import Project'}
            canClose={true}
            disableBackdropClick
            dialogSize={DialogSize.MEDIUM_LARGE}
        >
            <DisplayComponentBaseView isDirty={true} handleSaveButtonClick={handleSubmit}>
                <ScrollArea h={'100%'} scrollbars={'y'} offsetScrollbars={'y'} type="auto">
                    {importFilesStep()}
                </ScrollArea>
            </DisplayComponentBaseView>
        </ResizableDialog>
    );
};
